<note-acks *ngIf="ackNotes.length" [notes]="ackNotes" (notesCompleted)="signOn()">
</note-acks>

<div *ngIf="!ackNotes.length">
    <div *ngIf="!ackNotes.length && !signOnCompleted">
        <!--Shift Select-->
        <div *ngIf="scheduledShifts.length" class="p-grid">
            <div class="p-col-12">
                <label>Shift Selection</label>
                <p-dropdown [options]="scheduledShifts" appendTo="body" optionLabel="displayName"
                            [disabled]="loadingShifts || signOnPending"
                            [(ngModel)]="selectedShift"></p-dropdown>
            </div>
        </div>

        <!--Role Select-->
        <div *ngIf="roles.length" class="p-grid">
            <div class="p-col-12">
                <label>Role Selection</label>
                <p-dropdown [options]="roles" appendTo="body" optionLabel="name"
                            [disabled]="loadingShifts || signOnPending"
                            [(ngModel)]="selectedRole"></p-dropdown>
            </div>
        </div>

        <!--Time Input-->
        <div class="p-grid">
            <div class="time-input p-col-12 p-sm-6">
                <label>Shift Start</label>
                <p-calendar [(ngModel)]="shiftStart"
                            [readonlyInput]="true"
                            [touchUI]="isMobile"
                            [ngClass]="{'ng-invalid ng-dirty': !signOnEnabled}"
                            appendTo="body"
                            [disabled]="loadingShifts || signOnPending"
                            [showTime]="true">
                </p-calendar>
            </div>
            <div class="time-input p-col-12 p-sm-6">
                <label>Shift End</label>
                <p-calendar [(ngModel)]="shiftEnd"
                            [readonlyInput]="true"
                            [touchUI]="isMobile"
                            [ngClass]="{'ng-invalid ng-dirty': !signOnEnabled}"
                            appendTo="body"
                            [disabled]="loadingShifts || signOnPending"
                            [showTime]="true">
                </p-calendar>
            </div>
        </div>

        <!--Loading Shifts Notice-->
        <div *ngIf="loadingShifts">
            <p-message severity="info" text="Loading Shifts"></p-message>
        </div>

        <!--Shift out of range Warning-->
        <div *ngIf="!signOnEnabled">
            <p-message severity="warn"
                       text="The shift start must come before the end of the shift">
            </p-message>
        </div>
    </div>
</div>

<div class="signon-completed text-center" *ngIf="signOnCompleted">
    <div>
        <span class="fa fa-check-circle fa-4x text-success"></span>
    </div>
    <br>
    <div class="fa-lg">
        You are now on shift {{selectedRole ? 'as ' + selectedRole.name : ''}}
    </div>
</div>


<ng-container *ngIf="buttonTemplate as bt; else buttonContainer">
    <ng-container [ngTemplateOutlet]="bt" [ngTemplateOutletContext]="{'buttonTemplate': defaultButtonTemplate}"></ng-container>
</ng-container>

<ng-template #buttonContainer>
    <ng-container *ngTemplateOutlet="defaultButtonTemplate"></ng-container>
</ng-template>

<ng-template #defaultButtonTemplate>
    <ng-container *ngIf="!signOnCompleted">
        <button class="p-button-primary w-100"
            pButton
            [label]="signOnPending ? 'Signing on' : 'Sign on'"
            [icon]="signOnPending ? 'pi pi-spin pi-spinner' : ''"
            [disabled]="!signOnEnabled || loadingShifts || signOnPending"
            (click)="!signOnPending && presentAcksForRole()">
        </button>
    </ng-container>
</ng-template>